/**
 * Motion and performance utilities
 */
import { browser } from '$app/environment';

/**
 * Check if user prefers reduced motion
 */
export function prefersReducedMotion(): boolean {
	if (!browser) return false;
	return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Check if device is mobile (by screen width)
 */
export function isMobileDevice(): boolean {
	if (!browser) return false;
	return window.innerWidth < 768;
}

/**
 * Check if device is low-powered (mobile or reduced motion)
 */
export function isLowPowerMode(): boolean {
	return prefersReducedMotion() || isMobileDevice();
}

/**
 * Get appropriate animation frame rate divisor for performance
 * Returns 1 for full frame rate, 2 for half, etc.
 */
export function getFrameRateDivisor(): number {
	if (prefersReducedMotion()) return 0; // No animation
	if (isMobileDevice()) return 2; // Half frame rate on mobile
	return 1; // Full frame rate
}

/**
 * Create a reactive motion preference store.
 * Uses Svelte 5 runes - test in component context.
 */
/* v8 ignore start */
export function createMotionPreference() {
	let reducedMotion = $state(prefersReducedMotion());

	if (browser) {
		const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
		mediaQuery.addEventListener('change', (e) => {
			reducedMotion = e.matches;
		});
	}

	return {
		get reducedMotion() {
			return reducedMotion;
		}
	};
}
/* v8 ignore stop */
